import { FC, memo, useEffect, useState } from 'react';
import { Periodicity } from '../../time-period-selector/PeriodsTypes';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { ProductType } from '@pages/product-analyzer/Product';

interface WarningCurrencyContainerProps {
  productType: ProductType;
  periodicity: Periodicity;
  period: BaseTimePeriod;
}

const WarningCurrencyContainer: FC<WarningCurrencyContainerProps> = ({ productType, periodicity, period }) => {
  const [, setIsDismiss] = useState(false); //NOSONAR typescript:S6754
  const pagesConfig = usePageConfig();

  const { appliedFilters, pageType } = pagesConfig;
  /**
   * Reset dismiss state when filters or selected period are changed
   */
  useEffect(() => {
    setIsDismiss(false);
  }, [appliedFilters[pageType].selectedFilters, period]);

  return null;
};

export default memo(WarningCurrencyContainer);
